export default __webpack_public_path__ + "static/media/left-right_offer.fda00fb7.jpg";